export const getTroubleshootingState = (state) => state.troubleshooting;
